/** MUI */
import { Box, Button, Grid, Typography, useMediaQuery } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";

/** Redux */
import { getDashboardTOC, getScroll } from "@/src/_appStore/Common";
import { useSelector } from "react-redux";

/** Helpers */
import clsx from "clsx";
import { useTranslation } from "react-i18next";

/** UI */
import TableOfContents from "./TOC/TableOfContents";

const useStyles = makeStyles((theme) => ({
    PageTitle: {
        // fontSize: "calc(1.6666667vw)",
        // fontWeight: 700,
        fontWeight: 600,
        fontSize: "1.77777778rem",
        color: theme.palette.primary.main,
        height: "calc(3.33vw)",
        display: "flex",
        minWidth: 523,
        alignItems: "center",
        marginTop: 0,
        "&:focus-visible": {
            ...theme.outliness,
        },
        [theme.breakpoints.down("xl")]: {
            fontSize: "1.33333334rem",
            flexGrow: 1,
        },
        [theme.breakpoints.down("lg")]: {},
        [theme.breakpoints.down("md")]: {
            minWidth: "calc(100vw - 64px)",
            height: "auto",
            justifyContent: "space-between",
            fontSize: "1rem",
        },
        [theme.breakpoints.down("sm")]: {},
        ["@media (max-width: 280px)"]: {
            height: "auto",
            fontSize: "1.77777778rem",
            marginTop: theme.spacing(2),
        },
    },
    PageTitleName: {
        opacity: 1,
        [theme.breakpoints.up("md")]: {
            fontSize: "75%",
        },
    },
    LinkBtn: {
        textTransform: "none",
        fontSize: "1.11111111rem",
        letterSpacing: "0.00938em",
        fontWeight: "normal",
        borderRadius: 0,
        padding: 0,
        "& + &": {
            paddingLeft: theme.spacing(1),
            [theme.breakpoints.up("md")]: {},
        },
        "&:hover": {
            textDecoration: "underline",
            backgroundColor: "transparent",
        },
        [theme.breakpoints.down("lg")]: {
            fontSize: "1rem",
            height: 40,
        },
        [theme.breakpoints.down("md")]: {
            padding: 0,
        },
        [theme.breakpoints.down("sm")]: {
            fontSize: "0.88888889rem",
        },
    },
    topLinksWrap: {
        display: "flex",
        gap: theme.spacing(3),
        marginRight: 8,
        [theme.breakpoints.down("lg")]: {
            gap: theme.spacing(1),
            marginRight: 4,
        },
        [theme.breakpoints.down("md")]: {
            gap: theme.spacing(1),
        },
        [theme.breakpoints.down("sm")]: {
            maxWidth: 280,
            justifyContent: "space-between",
        },
        ["@media (max-width: 320px)"]: {
            maxWidth: "unset",
            width: "100%",
        },
    },
}));
const PageTitle = (props) => {
    const { area, modules, gotoDB, isCalc } = props;

    const classes = useStyles();
    const { t, i18n } = useTranslation();

    /** States */
    /** - redux */
    const appScroll = useSelector(getScroll);
    const dashboardTOC = useSelector(getDashboardTOC);

    const downMd = useMediaQuery((theme) => theme.breakpoints.down("md"));

    return (
        <Grid
            container
            spacing={0}
            sx={{
                // py: 5,
                pt:2.375,
                pb:1.5,
                position: dashboardTOC ? "sticky" : "static",
                top: { xs: 34, lg: 64 },
                zIndex: 1,
            }}
        >
            <Grid item xs={12} sx={{ backgroundColor: "#fff" }}>
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        flexWrap: "wrap",
                        gap: { xs: 0, md: 2 },
                        backgroundColor: "#fff",
                        pb: 1,
                        boxShadow: dashboardTOC && appScroll > 23 ? "0px 30px 16px -32px rgba(0,0,0,0.2)" : "none",
                    }}
                    id={"sticky_box"}
                >
                    <Typography
                        variant={"h4"}
                        className={classes.PageTitle}
                        component={"h2"}
                        id={"dashboard-main-title"}
                        tabIndex={-1}
                    >
                        {dashboardTOC && !downMd ? <TableOfContents data={modules} area={area} /> : null}

                        {/* <span className={clsx(appScroll > 23 && classes.PageTitleName)}>{area}</span> */}
                        <span >{area}</span>

                        {dashboardTOC && downMd ? <TableOfContents data={modules} area={area} /> : null}
                    </Typography>

                    <Box className={classes.topLinksWrap}>
                        {!!isCalc ? (
                            <Button
                                className={classes.LinkBtn}
                                href={"/katalog/waloryzacja"}
                                sx={{ py: 0, pr: 2, borderRadius: 0 }}
                            >
                                {t("Dane do waloryzacji")}
                            </Button>
                        ) : (
                            ""
                        )}
                        <Button
                            className={classes.LinkBtn}
                            sx={{ py: 0, pl: 2 }}
                            href={`/${i18n.language}/baza-danych`}
                            onClick={gotoDB}
                        >
                            {t("Więcej danych")}
                        </Button>
                    </Box>
                </Box>
            </Grid>
        </Grid>
    );
};

export default PageTitle;
